// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_om-0";
export var discountCodeInput = "_om-1";